export default function isSurveyFilledById (id, array) {
    return array.filter(item => item.id === id).length > 0
}